import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDraggable } from '@dnd-kit/core';
import { forwardRef, memo, useMemo } from 'react';
import { Image } from '../../../ui';
import { StyledCardLink, StyledImageCardText, StyledImageWrapper, StyledWrapper, } from './ImageCard.style';
export const ImageCard = memo(forwardRef(function ImageCard({ source, details, data, title, draggable, active = false, onClick = () => {
    return;
}, }, ref) {
    const imageCardDetails = details;
    const imageSource = source instanceof Array ? source[0] : source;
    const draggableHandlers = useDraggable({
        id: imageSource,
        data: {
            type: ['canvas'],
            source: imageSource,
            title,
            details: data,
        },
    });
    const draggableData = useMemo(() => {
        return draggable
            ? Object.assign(Object.assign({ ref: draggableHandlers.setNodeRef }, draggableHandlers.listeners), draggableHandlers.attributes) : {};
    }, [draggable, draggableHandlers]);
    return (_jsx(StyledWrapper, Object.assign({}, draggableData, { onClick: (event) => {
            event.stopPropagation();
            onClick({
                source: imageSource,
                action: 'click',
                details: data,
            });
        }, selected: (imageCardDetails === null || imageCardDetails === void 0 ? void 0 : imageCardDetails.selected) || active, disabled: imageCardDetails === null || imageCardDetails === void 0 ? void 0 : imageCardDetails.disabled, children: _jsxs(StyledCardLink, { href: imageCardDetails === null || imageCardDetails === void 0 ? void 0 : imageCardDetails.link, children: [imageSource && (_jsx(StyledImageWrapper, { maxHeight: imageCardDetails === null || imageCardDetails === void 0 ? void 0 : imageCardDetails.maxHeight, children: _jsx(Image, { source: imageSource, ref: ref, draggable: draggable }) })), !!title && _jsx(StyledImageCardText, { children: title, size: "BodyHeavy" })] }) })));
}));
//# sourceMappingURL=ImageCard.js.map